import { render, staticRenderFns } from "./NeuroVisuelle.vue?vue&type=template&id=3b7a8d2c"
import script from "./NeuroVisuelle.vue?vue&type=script&lang=js"
export * from "./NeuroVisuelle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports